export type USPListItemType = {
  usp1: string;
  usp2: string;
  usp3: string;
  usp4?: string | null;
};

export type USPMetaDataType = {
  title: string;
  information_title: string;
  information_description: string;
  price_text: string;
};

// Define a type for all doors and their USPs
export type USPLists = {
  [doorName: string]: USPListItemType;
};

export const toolsMetaData: USPMetaDataType = {
  title: "Vergelijkbare producten",
  information_title: "Gereedschap",
  information_description: "",
  price_text: "inclusief BTW en verzending",
};

export const glassUsps: USPListItemType = {
  usp1: "Milieuvriendelijke glasreiniger",
  usp2: "Gebruik glasdoek voor streeploos effect",
  usp3: "Kies voor een starterset of navulling",
};

export const glassNewSetUSP: USPListItemType = {
  usp1: "Streeploos effect",
  usp2: "Ruim 400 keer uitwasbaar",
  usp3: "Milieuvriendelijk geproduceerd",
};

export const glassNavulUSP: USPListItemType = {
  usp1: "Milieuvriendelijke allesreiniger",
  usp2: "Op basis van plantaardige oliën",
  usp3: "Kies voor een starterset of navulling",
};

export const glassMetaData: USPMetaDataType = {
  title: "Vergelijkbare producten",
  information_title: "Glasreiniger",
  information_description:
    "De glasreiniger en glasdoek van GewoonGers bieden de perfecte combinatie om jouw glaswand of glazen deur schoon te houden.",
  price_text: "inclusief BTW en verzending",
};

export const paintUsps: USPListItemType = {
  usp1: "Geschikt voor zowel houten- als metalen kozijnen",
  usp2: "Stem kozijn en nieuwe deur geheel op elkaar af",
  usp3: "Geschikt voor het schilderen van 2 à 3 kozijnen",
};

export const paintMetaData: USPMetaDataType = {
  title: "Kleur",
  information_title: "Verfset",
  information_description:
    "De GewoonGers verfsets zijn samengesteld om je kozijn af te stemmen op je nieuwe deur. Zo kun je het bestaande kozijn in een handomdraai een nieuwe uitstraling geven. De verfset bestaat uit matte lak, primer, een verfbakje, tape, kwast, verfroller en schuurpads.",
  price_text: "inclusief BTW en verzending",
};

export const voucherUsps: USPListItemType = {
  usp1: "Kies uit verschillende bedragen",
  usp2: "Altijd inclusief leuke cadeauverpakking",
  usp3: "Na bestelling binnen 2 werkdagen verzonden",
};

export const voucherMetaData: USPMetaDataType = {
  title: "Vergelijkbare producten",
  information_title: "Cadeaukaart",
  information_description:
    "Cadeaukaarten van GewoonGers zijn altijd inclusief geschenkverpakking. Wil je een cadeaukaart van een andere waarde? Neem dan contact met ons op.",
  price_text: "inclusief BTW en verzending",
};

export const acousticPanelUsps: USPListItemType = {
  usp1: "Gemaakt in eigen fabriek in Vlaardingen",
  usp2: "Geleverd door heel Nederland",
  usp3: "Makkelijk zelf te monteren",
};

export const zenEnZachtMetaData: USPMetaDataType = {
  title: "Kleur",
  information_title: "Kleur",
  information_description:
    "Bij iedere collectie zijn speciaal een aantal kleuren geselecteerd die mooi passen bij de beige of zwarte, vilten ondergrond. Maak hier je kleurkeuze.",
  price_text: "inclusief BTW",
};

export const acousticPanelMontageServiceUsps: USPListItemType = {
  usp1: "Inclusief montagekit (high-tack)",
  usp2: "Panelen worden ter plaatse op maat gemaakt",
  usp3: "Inclusief afvoeren restmateriaal en verpakkingsmateriaal",
  usp4: "Kosten zijn inclusief levering",
};

export const doorUsps: USPLists = {
  opdekdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Op maat voor jouw kozijn, geen verbouwing nodig",
    usp3: "Óók geschikt voor houten kozijnen",
  },
  stompedeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Op maat voor jouw kozijn, geen verbouwing nodig",
    usp3: "Óók geschikt voor houten kozijnen",
  },
  opdekdeurmetkozijn: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ter vervanging van het oude opdekkozijn",
    usp3: "Zonder verbouwen een deur tot aan het plafond",
  },
  scharnierdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  taatsdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  selfAssembly: {
    usp1: "Speciaal op maat gemaakt per bestelling",
    usp2: "Gemaakt in eigen fabriek in Vlaardingen",
    usp3: "Niet tevreden? Geld terug",
  },
  schuifdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Inclusief soft-close systeem",
  },
  dubbel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  dubbeleschuifdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Inclusief soft-close systeem",
  },
  dubbelescharnierdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Demontabel dus leverbaar op lastiger bereikbare plekken",
  },
  taatsdeur1paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  schuifdeur1paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Inclusief soft-close systeem",
  },
  scharnierdeur1paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  paneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Demontabel dus leverbaar op lastiger bereikbare plekken",
  },
  dubbel1paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  dubbeleschuifdeur1paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Inclusief soft-close systeem",
  },
  scharnierpaneelscharniertrap: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  schuifpaneelschuiftrap: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ruimte- én energiebesparende oplossing",
    usp3: "Inclusief soft-close systeem",
  },
  taatsdeur2paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  taatsdeurpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  schuifdeurpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ruimtebesparende oplossing zonder verlies lichtinval",
    usp3: "Inclusief soft-close systeem",
  },

  paneelpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Demontabel dus leverbaar op lastiger bereikbare plekken",
  },
  scharnierdeur2paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  schuifdeur2paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ruimtebesparende oplossing zonder verlies lichtinval",
    usp3: "Inclusief soft-close systeem",
  },
  dubbelescharnierdeur1paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  dubbel2paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  dubbeleschuifdeur2paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ruimtebesparende oplossing zonder verlies lichtinval",
    usp3: "Inclusief soft-close systeem",
  },
  schuifdeurschuifdeurpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ruimtebesparende oplossing zonder verlies lichtinval",
    usp3: "Inclusief soft-close systeem",
  },
  taatsdeurtaatsdeurpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Geen kozijn nodig, opent naar twee kanten",
  },
  dubbelescharnierdeur2paneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  paneelpaneelpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Óók toepasbaar bij vloerverwarming",
    usp3: "Demontabel dus leverbaar op lastiger bereikbare plekken",
  },
  schuifdeurpaneelpaneelschuifdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Ruimtebesparende oplossing zonder verlies lichtinval",
    usp3: "Inclusief soft- close systeem",
  },
  scharnierdeurpaneelscharnierdeur: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
  kaderdeur: {
    usp1: "Uit eigen fabriek in Vlaardingen",
    usp2: "Op maat voor een vaste prijs",
    usp3: "Snelle levering door heel Nederland",
  },
  dubbelekaderdeur: {
    usp1: "Uit eigen fabriek in Vlaardingen",
    usp2: "Op maat voor een vaste prijs",
    usp3: "Snelle levering door heel Nederland",
  },
  zakelijkkozijn: {
    usp1: "Uit eigen fabriek in Vlaardingen",
    usp2: "Op maat voor een vaste prijs",
    usp3: "Snelle levering door heel Nederland",
  },
  profiel: {
    usp1: "Uit eigen fabriek in Vlaardingen",
    usp2: "Keuze uit 16 verschillende kleuren",
    usp3: "Snelle levering door heel Nederland",
  },
  scharnierdeurpaneelpaneel: {
    usp1: "Gratis inmeetservice bij jou thuis, betaal later",
    usp2: "Extra slanke kozijnen voor moderne uitstraling",
    usp3: "Deur kan 180 graden open",
  },
};
